<template>
	<div id="langham-form" class="container-fluid">
		<div class="welcome-text">
	    <h4 class="welcome-head">Welcome to The Langham, New York!</h4>
	    <p class="welcome-sub">Choose how you would like to connect</p>
	  </div>
	  <!-- Accordion -->
	  
	  <details data-section="guests" open>
	    <summary role="button" class="close-accordion">
		    <div class="flod">
	    		<img v-if="activeSection == 'guests'" class="star" src="@/components/custom/langhamNewYorkNew/img/smallStarBlue.svg" alt="">
	    		<img v-else src="@/components/custom/langhamNewYorkNew/img/plusIcon.svg" alt="">
	    	</div>
	    	<p>Resident Guests</p>
	    </summary>
	    <div>
	    	<div class="form-contain">
	    		<!-- <span class="section-title left">*Automatic upgrade to Premium Wi-Fi for Brilliant by Langham members</span> -->
		    	<form class="form-container">
			    	<div class="two-wrapper">
			    		<div class="half">
							  <!-- Input outside label -->
							  <label for="room_number" class="label-style">Room Number*</label>
							  <input
							    type="room_number"
							    id="room_number"
							    v-model="form.room_guests.room_number"
							    class="input-style"
							  />
							  <span class="error-text">Please enter the room number</span>
							</div>
							<div class="half">
							  <!-- Input outside label -->
							  <label for="last_name" class="label-style">Last Name*</label>
							  <input
							    type="last_name"
							    id="last_name"
							    v-model="form.room_guests.last_name"
							    class="input-style"
							  />
							  <span class="error-text">Please enter your surname</span>
							</div>
						</div>
					  <fieldset class="checkbox" id="checkbox-guests">
						  <input type="checkbox" id="accept-form-guests" name="accept" v-model="form.room_guests.terms" />
						  <label htmlFor="accept-form-guests">I hereby agree with all the terms and conditions for the use of the internet*</label>
						</fieldset>
						<span class="error-text">Please agree to our internal terms and conditions</span>
						<a data-form="room_guests" class="top-bottom-margin solid-button center submit-data">CONNECT</a>
					</form>
				</div>
	    </div>
	  </details>
	  <!-- <details>
	    <summary role="button" class="close-accordion">
		    <div class="flod">
	    		<img src="@/components/custom/langhamNewYorkNew/img/plusIcon.svg" alt="">
	    	</div>
	    	<p>Other Guests</p>
	    </summary>
	    <p>
	    	<div class="form-contain">
		    	<form class="form-container">
			    	<fieldset class="checkbox">
						  <input type="checkbox" id="accept-form-other" name="accept" v-model="form.other_guests.terms" />
						  <label htmlFor="accept-form-other">I hereby agree with all the terms and conditions for the use of the internet*</label>
						</fieldset>
						<a data-form="other_guests" class="solid-button center submit-data">CONNECT</a>
					</form>
				</div>
	    </p>
	  </details> -->
	  <details data-section="access">
	    <summary role="button" class="close-accordion">
		    <div class="flod">
	    		<img v-if="activeSection == 'access'" class="star" src="@/components/custom/langhamNewYorkNew/img/smallStarBlue.svg" alt="">
	    		<img v-else src="@/components/custom/langhamNewYorkNew/img/plusIcon.svg" alt="">
	    	</div>
	    	<p>Access Code</p>
	    </summary>
	    <div>
	    	<div class="form-contain">
		    	<form class="form-container">
					  <!-- Input outside label -->
					  <label for="access_code" class="label-style">Access Code*</label>
					  <input
					    type="access_code"
					    id="access_code"
					    v-model="form.access_code.access_code"
					    class="input-style"
					  />
					  <span class="error-text">Please enter the conference code</span>
					  <fieldset class="checkbox" id="checkbox-ac">
						  <input type="checkbox" id="accept-form-ac" name="accept-form-ac" v-model="form.access_code.terms" />
						  <label htmlFor="accept-form-ac">I hereby agree with all the terms and conditions for the use of the internet*</label>
						</fieldset>
						<span class="error-text">Please agree to our internal terms and conditions</span>
					  <input type='submit' data-form="access_code" class="solid-button center submit-data top-bottom-margin" value="CONNECT" />
					</form>
				</div>
			</div>
	  </details>
	  <details data-section="join">
	    <summary id="signin-join" role="button" class="close-accordion">
	    	<div class="flod">
	    		<img v-if="activeSection == 'join'" class="star" src="@/components/custom/langhamNewYorkNew/img/smallStarBlue.svg" alt="">
	    		<img v-else src="@/components/custom/langhamNewYorkNew/img/plusIcon.svg" alt="">
	    	</div>
	    	<p>Premium Wifi - Enroll into Brilliant by Langham</p>
	    </summary>
	    <div>
	    	<div class="form-contain">
		    	<!-- sign in form -->
		    	<form id="signin-form" class="form-container">
		    		<span class="section-title left">Join now for free to enjoy Premium Wifi, Dining Discounts, Exclusive Member Room Rates and more!</span>
            <p class="section-subtitle">Already a Member? Click "SIGN IN" below</p>
			    	<label class="label-style">Sign In Method*</label>
			    	<select name="signin-method" aria-label="Sign In Method" v-model="form.signin.usernameIsMemberNumber" class="half left input-style" required>
						  <option :value="0">Email Address</option>
						  <option :value="1">Membership Number</option>
						</select>
						<div v-if="form.signin.usernameIsMemberNumber" class="two-wrapper">
							<div class="half">
							  <!-- Input outside label -->
							  <label for="membership-signin" class="label-style">Membership Number*</label>
							  <input
							    type="username"
							    id="membership-signin"
							    v-model="form.signin.username"
							    class="input-style"
							  />
							  <span class="error-text">Please provide your membership number</span>
							</div>
							<div class="half">
						  	<!-- Input outside label -->
						  	<label for="password-signin" class="label-style">Password*</label>
						  	<input
							    type="password"
							    id="password-signin"
							    v-model="form.signin.password"
							    class="input-style"
							  />
							  <span class="error-text">Please enter your account password</span>
							</div>
						</div>
						<div v-else class="two-wrapper">
							<div class="half">
							  <!-- Input outside label -->
							  <label for="username-signin" class="label-style">Email Address*</label>
							  <input
							    type="username"
							    id="username-signin"
							    v-model="form.signin.username"
							    class="input-style"
							  />
							  <span class="error-text">Please fill in your email address</span>
							  <span class="error-text">Please use a valid email format</span>
							</div>
							<div class="half">
						  	<!-- Input outside label -->
						  	<label for="password" class="label-style">Password*</label>
						  	<input
							    type="password"
							    id="password"
							    v-model="form.signin.password"
							    class="input-style"
							  />
							  <span class="error-text">Please enter your account password</span>
							</div>
						</div>
					  <fieldset class="checkbox" id="signin-terms-accept">
						  <input type="checkbox" id="accept-form-signin" name="accept" v-model="form.signin.terms" />
						  <label htmlFor="accept-form-signin">I hereby agree with all the terms and conditions for the use of the internet*</label>
						</fieldset>
						<span class="error-text">Please agree to our internet terms and conditions</span>
						<div class="two-wrapper make-room">
							<input 
								type="submit"
								value="SIGN IN" 
								id="signin-button"
						    data-form="signin"
						    class="half solid-button submit-data" />
							<a id="join-switch-button" class="skip-button half outline-button">JOIN NOW</a>
						</div>
					</form>

				  <!-- join now form -->
				  <form id="join-form" class="form-container">
		    		<span class="section-title left">Join now for free to enjoy Premium Wifi, Dining Discounts, Exclusive Member Room Rates and more!<a class="skip-button">Skip</a></span>
		    		<div class="two-wrapper">
		    			<div class="half">
				    		<label for="first_name" class="label-style">First Name/Given Name*</label>
							  <input
							    type="first_name"
							    id="first_name"
							    v-model="form.join.user.first_name"
							    class="input-style"
							  />
							  <span class="error-text">Please remember to fill in your first name</span>
						  	<p class="sub-label">Same as passport (in English)</p>
						  </div>
						  <div class="half">
							  <label for="last_name_join" class="label-style">Last Name/Family Name*</label>
							  <input
							    type="last_name"
							    id="last_name_join"
							    v-model="form.join.user.last_name"
							    class="input-style"
							  />
							  <span class="error-text">It looks like you've forgotten to fill in your surname</span>
							  <p class="sub-label">Same as passport (in English)</p>
							</div>
						</div>
						<div class="two-wrapper">
							<div class="half">
								<label class="label-style">Country/Region Code*</label>
							  <select name="country_code" aria-label="Country Region Code" v-model="form.join.country_prefix" required class="input-style">
								  <option v-for="country in countries" :key="country.code" :value="country.code">{{country.name}}  {{country.ISD_code}}</option>
								</select>
							</div>
							<div class="half">
							  <!-- Input outside label -->
							  <label for="mobile_number" class="label-style">Mobile Number*</label>
							  <input
							    type="mobile_number"
							    id="mobile_number"
							    v-model="form.join.mobile"
							    class="input-style"
							  />
							  <span class="error-text">Don't forget to fill in your mobile number, so we can get in touch</span>
							</div>
						</div>
						<div class="two-wrapper">
							<div class="half">
							  <!-- Input outside label -->
							  <label for="join_email_address" class="label-style">Email Address*</label>
							  <input
							    type="email_address"
							    id="join_email_address"
							    v-model="form.join.user.email"
							    class="input-style"
							  />
							  <span class="error-text">Don't forget to fill in your email address so we know where to contact you</span>
							  <span class="error-text">Please provide a valid email address</span>
							</div>
							<div class="half">
								<label class="label-style">Location*</label>
					    	<select name="country" aria-label="Location" v-model="form.join.country" required class="input-style">
								  <option v-for="country in countries" :key="country.code" :value="country.code">{{country.name}}</option>
								</select>
							</div>
						</div>
						<div class="two-wrapper">
							<div class="half">
							  <label class="label-style">Province/State</label>
					    	<select name="region" aria-label="Province/State" v-model="form.join.region_id" required class="input-style">
                  <option :value="null">-Not Applicable-</option>
								  <option v-for="region in regions" :key="region.region_id" :value="region.region_id">{{region.region_name}}</option>
								</select>
							</div>
							<div class="half">
								<label class="label-style">City</label>
					    	<select name="city" aria-label="City" v-model="form.join.city_id" required class="input-style">
                  <option :value="null">-Not Applicable-</option>
								  <option v-for="city in cities" :key="city.city_id" :value="city.city_id">{{city.city_name}}</option>
								</select>
							</div>
						</div>
						<div class="two-wrapper">
							<div class="half">
					  		<label for="password-join" class="label-style">Password*</label>
							  <input
							    type="password"
							    id="password-join"
							    v-model="form.join.password"
							    class="input-style"
							  />
							  <span class="error-text">Password requirements:
							  	<ul style="color: red;">
							  		<li>At least 8 valid characters</li>
							  		<li>A combination of letters (a-z,A-Z) and numbers (0-9)</li>
							  		<li>At least one upper case and one lower case</li>
							  		<li>At least one special character: @$!%*#?&</li>
							  	</ul>
							  </span>
							</div>
							<div class="half">
							  <label for="confirm_password" class="label-style">Confirm Password*</label>
							  <input
							    type="password"
							    id="confirm_password"
							    class="input-style"
							  />
							  <span class="error-text">x, Sorry, the password you entered is incorrect</span>
							</div>
						</div>
					  <fieldset class="checkbox" id="accept-form-1">
						  <input type="checkbox" id="accept-form-join" name="accept" v-model="form.join.tc_internet" />
						  <label htmlFor="accept-form-join">I hereby agree with all the terms and conditions for the use of the internet*</label>
						</fieldset>
						<span class="error-text">Please agree to our internet terms and conditions</span>
						
						<fieldset class="checkbox" id="accept-form-2">
						  <input type="checkbox" id="accept-form-brilliant" name="accept-brilliant" v-model="form.join.tc" />
						  <label htmlFor="accept-form-brilliant">I acknowledge and agree to the Brilliant by Langham Terms and Conditions*.</label>
						</fieldset>
						<span class="error-text">Please read and agree to the Brilliant by Langham Terms and Conditions</span>

						<fieldset class="checkbox">
						  <input type="checkbox" id="accept-form-marketing" name="accept-marketing" v-model="form.join.marketing" />
						  <label htmlFor="accept-form-marketing">I would like to sign up for news and marketing updates and consent to the use of my personal data for direct marketing purposes in accordance with the Privacy Policy.</label>
						</fieldset>

						<fieldset class="checkbox" id="accept-form-3">
						  <input type="checkbox" id="accept-form-data" name="accept-data" v-model="form.join.privacy" />
						  <label htmlFor="accept-form-data">I understand and consent to the processing of my personal data (including my sensitive personal data and that of minors under my guardianship); and provision of such personal data to local and overseas recipients, in accordance with Privacy Policy*.</label>
						</fieldset>
						<span class="error-text">Please read and agree to the Brilliant by Langham Privacy Policy</span>

						<fieldset class="checkbox" id="accept-form-4">
						  <input type="checkbox" id="accept-form-info" name="accept-info" v-model="form.join.info" />
						  <label htmlFor="accept-form-info">I confirm the information provided is correct*.</label>
						</fieldset>
						<span class="error-text">Please read and agree with the above statement.</span>

						<div class="make-room">
							<input
								type="submit"
								value="JOIN NOW"
								id="join-button"
						    data-form="join"
						    class="solid-button center submit-data"/>
							<a class="skip-button">Skip</a>
						</div>
					</form>
				</div>
	    </div>
	  </details>
	</div>
</template>

<script>
	import $ from 'jquery'
  import {HTTP} from '@/utilities/http'

	export default {
	  name: 'langham-form',
	  props: ['registration_methods', 'clickedJoin'],
	  components: {
	  },
	  watch: {
      'form.join.country'(newVal, oldVal) {
        // console.debug(`country changed from ${oldVal} to ${newVal}`);
        this.clearRegions();
        this.clearCities();
        this.fetchRegions(newVal);
      },
      'form.join.region_id'(newVal, oldVal) {
        // console.debug(`region_id changed from ${oldVal} to ${newVal}`);
        this.clearCities();
        this.fetchCities(newVal);
      },
    },
	  data(){
	    return{
	    	activeSection: null,
	    	access_code_valid: true,
      	access_code_error_text: 'Required',
				joined: false,
	    	registration_method_id: null,
	    	registration_method: {},
	    	form: {
	    		signin: {
	    			username: null,
	    			password: null,
	    			terms: false,
	    			usernameIsMemberNumber: 0
	    		},
	    		join: {
	    			user: {
	    				email: '',
	    				first_name: '',
	    				last_name: ''
	    			},
	    			country: "US",
	    			country_prefix: "US",
	    			mobile: '',
	    			password: '',
						tc_internet: 0,
						tc: 0,
						marketing: 0,
						privacy: 0,
						info: 0,
            region_id: '',
            city_id: '',
	    		},
	    		room_guests: {
	    			room_number: null,
	    			last_name: null,
	    			terms: false
	    		},
	    		other_guests: {
	    			terms: false
	    		},
	    		access_code: {
	    			access_code: null,
	    			terms: 0
	    		}
	    	},
        cities: [],
        regions: [],
	    	countries: [
			    {
			      "name": "Afghanistan",
			      "ISD_code": "93",
			      "code": "AF"
			    },
			    {
			      "name": "Aland Islands",
			      "ISD_code": "358",
			      "code": "AX"
			    },
			    {
			      "name": "Albania",
			      "ISD_code": "355",
			      "code": "AL"
			    },
			    {
			      "name": "Algeria",
			      "ISD_code": "213",
			      "code": "DZ"
			    },
			    {
			      "name": "AmericanSamoa",
			      "ISD_code": "1684",
			      "code": "AS"
			    },
			    {
			      "name": "Andorra",
			      "ISD_code": "376",
			      "code": "AD"
			    },
			    {
			      "name": "Angola",
			      "ISD_code": "244",
			      "code": "AO"
			    },
			    {
			      "name": "Anguilla",
			      "ISD_code": "1264",
			      "code": "AI"
			    },
			    {
			      "name": "Antarctica",
			      "ISD_code": "672",
			      "code": "AQ"
			    },
			    {
			      "name": "Antigua and Barbuda",
			      "ISD_code": "1268",
			      "code": "AG"
			    },
			    {
			      "name": "Argentina",
			      "ISD_code": "54",
			      "code": "AR"
			    },
			    {
			      "name": "Armenia",
			      "ISD_code": "374",
			      "code": "AM"
			    },
			    {
			      "name": "Aruba",
			      "ISD_code": "297",
			      "code": "AW"
			    },
			    {
			      "name": "Australia",
			      "ISD_code": "61",
			      "code": "AU"
			    },
			    {
			      "name": "Austria",
			      "ISD_code": "43",
			      "code": "AT"
			    },
			    {
			      "name": "Azerbaijan",
			      "ISD_code": "994",
			      "code": "AZ"
			    },
			    {
			      "name": "Bahamas",
			      "ISD_code": "1242",
			      "code": "BS"
			    },
			    {
			      "name": "Bahrain",
			      "ISD_code": "973",
			      "code": "BH"
			    },
			    {
			      "name": "Bangladesh",
			      "ISD_code": "880",
			      "code": "BD"
			    },
			    {
			      "name": "Barbados",
			      "ISD_code": "1246",
			      "code": "BB"
			    },
			    {
			      "name": "Belarus",
			      "ISD_code": "375",
			      "code": "BY"
			    },
			    {
			      "name": "Belgium",
			      "ISD_code": "32",
			      "code": "BE"
			    },
			    {
			      "name": "Belize",
			      "ISD_code": "501",
			      "code": "BZ"
			    },
			    {
			      "name": "Benin",
			      "ISD_code": "229",
			      "code": "BJ"
			    },
			    {
			      "name": "Bermuda",
			      "ISD_code": "1441",
			      "code": "BM"
			    },
			    {
			      "name": "Bhutan",
			      "ISD_code": "975",
			      "code": "BT"
			    },
			    {
			      "name": "Bolivia, Plurinational State of",
			      "ISD_code": "591",
			      "code": "BO"
			    },
			    {
			      "name": "Bosnia and Herzegovina",
			      "ISD_code": "387",
			      "code": "BA"
			    },
			    {
			      "name": "Botswana",
			      "ISD_code": "267",
			      "code": "BW"
			    },
			    {
			      "name": "Brazil",
			      "ISD_code": "55",
			      "code": "BR"
			    },
			    {
			      "name": "British Indian Ocean Territory",
			      "ISD_code": "246",
			      "code": "IO"
			    },
			    {
			      "name": "Brunei Darussalam",
			      "ISD_code": "673",
			      "code": "BN"
			    },
			    {
			      "name": "Bulgaria",
			      "ISD_code": "359",
			      "code": "BG"
			    },
			    {
			      "name": "Burkina Faso",
			      "ISD_code": "226",
			      "code": "BF"
			    },
			    {
			      "name": "Burundi",
			      "ISD_code": "257",
			      "code": "BI"
			    },
			    {
			      "name": "Cambodia",
			      "ISD_code": "855",
			      "code": "KH"
			    },
			    {
			      "name": "Cameroon",
			      "ISD_code": "237",
			      "code": "CM"
			    },
			    {
			      "name": "Canada",
			      "ISD_code": "1",
			      "code": "CA"
			    },
			    {
			      "name": "Cape Verde",
			      "ISD_code": "238",
			      "code": "CV"
			    },
			    {
			      "name": "Cayman Islands",
			      "ISD_code": " 345",
			      "code": "KY"
			    },
			    {
			      "name": "Central African Republic",
			      "ISD_code": "236",
			      "code": "CF"
			    },
			    {
			      "name": "Chad",
			      "ISD_code": "235",
			      "code": "TD"
			    },
					{
			      "name": "Mainland China",
			      "ISD_code": "86",
			      "code": "CN"
			    },
			    {
			      "name": "Chile",
			      "ISD_code": "56",
			      "code": "CL"
			    },
			    {
			      "name": "Christmas Island",
			      "ISD_code": "61",
			      "code": "CX"
			    },
			    {
			      "name": "Cocos (Keeling) Islands",
			      "ISD_code": "61",
			      "code": "CC"
			    },
			    {
			      "name": "Colombia",
			      "ISD_code": "57",
			      "code": "CO"
			    },
			    {
			      "name": "Comoros",
			      "ISD_code": "269",
			      "code": "KM"
			    },
			    {
			      "name": "Congo",
			      "ISD_code": "242",
			      "code": "CG"
			    },
			    {
			      "name": "Congo, The Democratic Republic of the Congo",
			      "ISD_code": "243",
			      "code": "CD"
			    },
			    {
			      "name": "Cook Islands",
			      "ISD_code": "682",
			      "code": "CK"
			    },
			    {
			      "name": "Costa Rica",
			      "ISD_code": "506",
			      "code": "CR"
			    },
			    {
			      "name": "Cote d'Ivoire",
			      "ISD_code": "225",
			      "code": "CI"
			    },
			    {
			      "name": "Croatia",
			      "ISD_code": "385",
			      "code": "HR"
			    },
			    {
			      "name": "Cuba",
			      "ISD_code": "53",
			      "code": "CU"
			    },
			    {
			      "name": "Cyprus",
			      "ISD_code": "357",
			      "code": "CY"
			    },
			    {
			      "name": "Czech Republic",
			      "ISD_code": "420",
			      "code": "CZ"
			    },
			    {
			      "name": "Denmark",
			      "ISD_code": "45",
			      "code": "DK"
			    },
			    {
			      "name": "Djibouti",
			      "ISD_code": "253",
			      "code": "DJ"
			    },
			    {
			      "name": "Dominica",
			      "ISD_code": "1767",
			      "code": "DM"
			    },
			    {
			      "name": "Dominican Republic",
			      "ISD_code": "1849",
			      "code": "DO"
			    },
			    {
			      "name": "Ecuador",
			      "ISD_code": "593",
			      "code": "EC"
			    },
			    {
			      "name": "Egypt",
			      "ISD_code": "20",
			      "code": "EG"
			    },
			    {
			      "name": "El Salvador",
			      "ISD_code": "503",
			      "code": "SV"
			    },
			    {
			      "name": "Equatorial Guinea",
			      "ISD_code": "240",
			      "code": "GQ"
			    },
			    {
			      "name": "Eritrea",
			      "ISD_code": "291",
			      "code": "ER"
			    },
			    {
			      "name": "Estonia",
			      "ISD_code": "372",
			      "code": "EE"
			    },
			    {
			      "name": "Ethiopia",
			      "ISD_code": "251",
			      "code": "ET"
			    },
			    {
			      "name": "Falkland Islands (Malvinas)",
			      "ISD_code": "500",
			      "code": "FK"
			    },
			    {
			      "name": "Faroe Islands",
			      "ISD_code": "298",
			      "code": "FO"
			    },
			    {
			      "name": "Fiji",
			      "ISD_code": "679",
			      "code": "FJ"
			    },
			    {
			      "name": "Finland",
			      "ISD_code": "358",
			      "code": "FI"
			    },
			    {
			      "name": "France",
			      "ISD_code": "33",
			      "code": "FR"
			    },
			    {
			      "name": "French Guiana",
			      "ISD_code": "594",
			      "code": "GF"
			    },
			    {
			      "name": "French Polynesia",
			      "ISD_code": "689",
			      "code": "PF"
			    },
			    {
			      "name": "Gabon",
			      "ISD_code": "241",
			      "code": "GA"
			    },
			    {
			      "name": "Gambia",
			      "ISD_code": "220",
			      "code": "GM"
			    },
			    {
			      "name": "Georgia",
			      "ISD_code": "995",
			      "code": "GE"
			    },
			    {
			      "name": "Germany",
			      "ISD_code": "49",
			      "code": "DE"
			    },
			    {
			      "name": "Ghana",
			      "ISD_code": "233",
			      "code": "GH"
			    },
			    {
			      "name": "Gibraltar",
			      "ISD_code": "350",
			      "code": "GI"
			    },
			    {
			      "name": "Greece",
			      "ISD_code": "30",
			      "code": "GR"
			    },
			    {
			      "name": "Greenland",
			      "ISD_code": "299",
			      "code": "GL"
			    },
			    {
			      "name": "Grenada",
			      "ISD_code": "1473",
			      "code": "GD"
			    },
			    {
			      "name": "Guadeloupe",
			      "ISD_code": "590",
			      "code": "GP"
			    },
			    {
			      "name": "Guam",
			      "ISD_code": "1671",
			      "code": "GU"
			    },
			    {
			      "name": "Guatemala",
			      "ISD_code": "502",
			      "code": "GT"
			    },
			    {
			      "name": "Guernsey",
			      "ISD_code": "44",
			      "code": "GG"
			    },
			    {
			      "name": "Guinea",
			      "ISD_code": "224",
			      "code": "GN"
			    },
			    {
			      "name": "Guinea-Bissau",
			      "ISD_code": "245",
			      "code": "GW"
			    },
			    {
			      "name": "Guyana",
			      "ISD_code": "595",
			      "code": "GY"
			    },
			    {
			      "name": "Haiti",
			      "ISD_code": "509",
			      "code": "HT"
			    },
			    {
			      "name": "Vatican City State",
			      "ISD_code": "379",
			      "code": "VA"
			    },
			    {
			      "name": "Honduras",
			      "ISD_code": "504",
			      "code": "HN"
			    },
			    {
			      "name": "Hong Kong SAR",
			      "ISD_code": "852",
			      "code": "HK"
			    },
			    {
			      "name": "Hungary",
			      "ISD_code": "36",
			      "code": "HU"
			    },
			    {
			      "name": "Iceland",
			      "ISD_code": "354",
			      "code": "IS"
			    },
			    {
			      "name": "India",
			      "ISD_code": "91",
			      "code": "IN"
			    },
			    {
			      "name": "Indonesia",
			      "ISD_code": "62",
			      "code": "ID"
			    },
			    {
			      "name": "Iran, Islamic Republic of Persian Gulf",
			      "ISD_code": "98",
			      "code": "IR"
			    },
			    {
			      "name": "Iraq",
			      "ISD_code": "964",
			      "code": "IQ"
			    },
			    {
			      "name": "Ireland",
			      "ISD_code": "353",
			      "code": "IE"
			    },
			    {
			      "name": "Isle of Man",
			      "ISD_code": "44",
			      "code": "IM"
			    },
			    {
			      "name": "Israel",
			      "ISD_code": "972",
			      "code": "IL"
			    },
			    {
			      "name": "Italy",
			      "ISD_code": "39",
			      "code": "IT"
			    },
			    {
			      "name": "Jamaica",
			      "ISD_code": "1876",
			      "code": "JM"
			    },
			    {
			      "name": "Japan",
			      "ISD_code": "81",
			      "code": "JP"
			    },
			    {
			      "name": "Jersey",
			      "ISD_code": "44",
			      "code": "JE"
			    },
			    {
			      "name": "Jordan",
			      "ISD_code": "962",
			      "code": "JO"
			    },
			    {
			      "name": "Kazakhstan",
			      "ISD_code": "77",
			      "code": "KZ"
			    },
			    {
			      "name": "Kenya",
			      "ISD_code": "254",
			      "code": "KE"
			    },
			    {
			      "name": "Kiribati",
			      "ISD_code": "686",
			      "code": "KI"
			    },
			    {
			      "name": "Korea, Democratic People's Republic of Korea",
			      "ISD_code": "850",
			      "code": "KP"
			    },
			    {
			      "name": "Korea, Republic of South Korea",
			      "ISD_code": "82",
			      "code": "KR"
			    },
			    {
			      "name": "Kuwait",
			      "ISD_code": "965",
			      "code": "KW"
			    },
			    {
			      "name": "Kyrgyzstan",
			      "ISD_code": "996",
			      "code": "KG"
			    },
			    {
			      "name": "Laos",
			      "ISD_code": "856",
			      "code": "LA"
			    },
			    {
			      "name": "Latvia",
			      "ISD_code": "371",
			      "code": "LV"
			    },
			    {
			      "name": "Lebanon",
			      "ISD_code": "961",
			      "code": "LB"
			    },
			    {
			      "name": "Lesotho",
			      "ISD_code": "266",
			      "code": "LS"
			    },
			    {
			      "name": "Liberia",
			      "ISD_code": "231",
			      "code": "LR"
			    },
			    {
			      "name": "Libyan Arab Jamahiriya",
			      "ISD_code": "218",
			      "code": "LY"
			    },
			    {
			      "name": "Liechtenstein",
			      "ISD_code": "423",
			      "code": "LI"
			    },
			    {
			      "name": "Lithuania",
			      "ISD_code": "370",
			      "code": "LT"
			    },
			    {
			      "name": "Luxembourg",
			      "ISD_code": "352",
			      "code": "LU"
			    },
			    {
			      "name": "Macao SAR",
			      "ISD_code": "853",
			      "code": "MO"
			    },
			    {
			      "name": "Macedonia",
			      "ISD_code": "389",
			      "code": "MK"
			    },
			    {
			      "name": "Madagascar",
			      "ISD_code": "261",
			      "code": "MG"
			    },
			    {
			      "name": "Malawi",
			      "ISD_code": "265",
			      "code": "MW"
			    },
			    {
			      "name": "Malaysia",
			      "ISD_code": "60",
			      "code": "MY"
			    },
			    {
			      "name": "Maldives",
			      "ISD_code": "960",
			      "code": "MV"
			    },
			    {
			      "name": "Mali",
			      "ISD_code": "223",
			      "code": "ML"
			    },
			    {
			      "name": "Malta",
			      "ISD_code": "356",
			      "code": "MT"
			    },
			    {
			      "name": "Marshall Islands",
			      "ISD_code": "692",
			      "code": "MH"
			    },
			    {
			      "name": "Martinique",
			      "ISD_code": "596",
			      "code": "MQ"
			    },
			    {
			      "name": "Mauritania",
			      "ISD_code": "222",
			      "code": "MR"
			    },
			    {
			      "name": "Mauritius",
			      "ISD_code": "230",
			      "code": "MU"
			    },
			    {
			      "name": "Mayotte",
			      "ISD_code": "262",
			      "code": "YT"
			    },
			    {
			      "name": "Mexico",
			      "ISD_code": "52",
			      "code": "MX"
			    },
			    {
			      "name": "Micronesia, Federated States of Micronesia",
			      "ISD_code": "691",
			      "code": "FM"
			    },
			    {
			      "name": "Moldova",
			      "ISD_code": "373",
			      "code": "MD"
			    },
			    {
			      "name": "Monaco",
			      "ISD_code": "377",
			      "code": "MC"
			    },
			    {
			      "name": "Mongolia",
			      "ISD_code": "976",
			      "code": "MN"
			    },
			    {
			      "name": "Montenegro",
			      "ISD_code": "382",
			      "code": "ME"
			    },
			    {
			      "name": "Montserrat",
			      "ISD_code": "1664",
			      "code": "MS"
			    },
			    {
			      "name": "Morocco",
			      "ISD_code": "212",
			      "code": "MA"
			    },
			    {
			      "name": "Mozambique",
			      "ISD_code": "258",
			      "code": "MZ"
			    },
			    {
			      "name": "Myanmar",
			      "ISD_code": "95",
			      "code": "MM"
			    },
			    {
			      "name": "Namibia",
			      "ISD_code": "264",
			      "code": "NA"
			    },
			    {
			      "name": "Nauru",
			      "ISD_code": "674",
			      "code": "NR"
			    },
			    {
			      "name": "Nepal",
			      "ISD_code": "977",
			      "code": "NP"
			    },
			    {
			      "name": "Netherlands",
			      "ISD_code": "31",
			      "code": "NL"
			    },
			    {
			      "name": "Netherlands Antilles",
			      "ISD_code": "599",
			      "code": "AN"
			    },
			    {
			      "name": "New Caledonia",
			      "ISD_code": "687",
			      "code": "NC"
			    },
			    {
			      "name": "New Zealand",
			      "ISD_code": "64",
			      "code": "NZ"
			    },
			    {
			      "name": "Nicaragua",
			      "ISD_code": "505",
			      "code": "NI"
			    },
			    {
			      "name": "Niger",
			      "ISD_code": "227",
			      "code": "NE"
			    },
			    {
			      "name": "Nigeria",
			      "ISD_code": "234",
			      "code": "NG"
			    },
			    {
			      "name": "Niue",
			      "ISD_code": "683",
			      "code": "NU"
			    },
			    {
			      "name": "Norfolk Island",
			      "ISD_code": "672",
			      "code": "NF"
			    },
			    {
			      "name": "Northern Mariana Islands",
			      "ISD_code": "1670",
			      "code": "MP"
			    },
			    {
			      "name": "Norway",
			      "ISD_code": "47",
			      "code": "NO"
			    },
			    {
			      "name": "Oman",
			      "ISD_code": "968",
			      "code": "OM"
			    },
			    {
			      "name": "Pakistan",
			      "ISD_code": "92",
			      "code": "PK"
			    },
			    {
			      "name": "Palau",
			      "ISD_code": "680",
			      "code": "PW"
			    },
			    {
			      "name": "Palestinian Territory, Occupied",
			      "ISD_code": "970",
			      "code": "PS"
			    },
			    {
			      "name": "Panama",
			      "ISD_code": "507",
			      "code": "PA"
			    },
			    {
			      "name": "Papua New Guinea",
			      "ISD_code": "675",
			      "code": "PG"
			    },
			    {
			      "name": "Paraguay",
			      "ISD_code": "595",
			      "code": "PY"
			    },
			    {
			      "name": "Peru",
			      "ISD_code": "51",
			      "code": "PE"
			    },
			    {
			      "name": "Philippines",
			      "ISD_code": "63",
			      "code": "PH"
			    },
			    {
			      "name": "Pitcairn",
			      "ISD_code": "872",
			      "code": "PN"
			    },
			    {
			      "name": "Poland",
			      "ISD_code": "48",
			      "code": "PL"
			    },
			    {
			      "name": "Portugal",
			      "ISD_code": "351",
			      "code": "PT"
			    },
			    {
			      "name": "Puerto Rico",
			      "ISD_code": "1939",
			      "code": "PR"
			    },
			    {
			      "name": "Qatar",
			      "ISD_code": "974",
			      "code": "QA"
			    },
			    {
			      "name": "Romania",
			      "ISD_code": "40",
			      "code": "RO"
			    },
			    {
			      "name": "Russia",
			      "ISD_code": "7",
			      "code": "RU"
			    },
			    {
			      "name": "Rwanda",
			      "ISD_code": "250",
			      "code": "RW"
			    },
			    {
			      "name": "Reunion",
			      "ISD_code": "262",
			      "code": "RE"
			    },
			    {
			      "name": "Saint Barthelemy",
			      "ISD_code": "590",
			      "code": "BL"
			    },
			    {
			      "name": "Saint Helena, Ascension and Tristan Da Cunha",
			      "ISD_code": "290",
			      "code": "SH"
			    },
			    {
			      "name": "Saint Kitts and Nevis",
			      "ISD_code": "1869",
			      "code": "KN"
			    },
			    {
			      "name": "Saint Lucia",
			      "ISD_code": "1758",
			      "code": "LC"
			    },
			    {
			      "name": "Saint Martin",
			      "ISD_code": "590",
			      "code": "MF"
			    },
			    {
			      "name": "Saint Pierre and Miquelon",
			      "ISD_code": "508",
			      "code": "PM"
			    },
			    {
			      "name": "Saint Vincent and the Grenadines",
			      "ISD_code": "1784",
			      "code": "VC"
			    },
			    {
			      "name": "Samoa",
			      "ISD_code": "685",
			      "code": "WS"
			    },
			    {
			      "name": "San Marino",
			      "ISD_code": "378",
			      "code": "SM"
			    },
			    {
			      "name": "Sao Tome and Principe",
			      "ISD_code": "239",
			      "code": "ST"
			    },
			    {
			      "name": "Saudi Arabia",
			      "ISD_code": "966",
			      "code": "SA"
			    },
			    {
			      "name": "Senegal",
			      "ISD_code": "221",
			      "code": "SN"
			    },
			    {
			      "name": "Serbia",
			      "ISD_code": "381",
			      "code": "RS"
			    },
			    {
			      "name": "Seychelles",
			      "ISD_code": "248",
			      "code": "SC"
			    },
			    {
			      "name": "Sierra Leone",
			      "ISD_code": "232",
			      "code": "SL"
			    },
			    {
			      "name": "Singapore",
			      "ISD_code": "65",
			      "code": "SG"
			    },
			    {
			      "name": "Slovakia",
			      "ISD_code": "421",
			      "code": "SK"
			    },
			    {
			      "name": "Slovenia",
			      "ISD_code": "386",
			      "code": "SI"
			    },
			    {
			      "name": "Solomon Islands",
			      "ISD_code": "677",
			      "code": "SB"
			    },
			    {
			      "name": "Somalia",
			      "ISD_code": "252",
			      "code": "SO"
			    },
			    {
			      "name": "South Africa",
			      "ISD_code": "27",
			      "code": "ZA"
			    },
			    {
			      "name": "South Sudan",
			      "ISD_code": "211",
			      "code": "SS"
			    },
			    {
			      "name": "South Georgia and the South Sandwich Islands",
			      "ISD_code": "500",
			      "code": "GS"
			    },
			    {
			      "name": "Spain",
			      "ISD_code": "34",
			      "code": "ES"
			    },
			    {
			      "name": "Sri Lanka",
			      "ISD_code": "94",
			      "code": "LK"
			    },
			    {
			      "name": "Sudan",
			      "ISD_code": "249",
			      "code": "SD"
			    },
			    {
			      "name": "Suriname",
			      "ISD_code": "597",
			      "code": "SR"
			    },
			    {
			      "name": "Svalbard and Jan Mayen",
			      "ISD_code": "47",
			      "code": "SJ"
			    },
			    {
			      "name": "Swaziland",
			      "ISD_code": "268",
			      "code": "SZ"
			    },
			    {
			      "name": "Sweden",
			      "ISD_code": "46",
			      "code": "SE"
			    },
			    {
			      "name": "Switzerland",
			      "ISD_code": "41",
			      "code": "CH"
			    },
			    {
			      "name": "Syrian Arab Republic",
			      "ISD_code": "963",
			      "code": "SY"
			    },
			    {
			      "name": "Taiwan",
			      "ISD_code": "886",
			      "code": "TW"
			    },
			    {
			      "name": "Tajikistan",
			      "ISD_code": "992",
			      "code": "TJ"
			    },
			    {
			      "name": "Tanzania, United Republic of Tanzania",
			      "ISD_code": "255",
			      "code": "TZ"
			    },
			    {
			      "name": "Thailand",
			      "ISD_code": "66",
			      "code": "TH"
			    },
			    {
			      "name": "Timor-Leste",
			      "ISD_code": "670",
			      "code": "TL"
			    },
			    {
			      "name": "Togo",
			      "ISD_code": "228",
			      "code": "TG"
			    },
			    {
			      "name": "Tokelau",
			      "ISD_code": "690",
			      "code": "TK"
			    },
			    {
			      "name": "Tonga",
			      "ISD_code": "676",
			      "code": "TO"
			    },
			    {
			      "name": "Trinidad and Tobago",
			      "ISD_code": "1868",
			      "code": "TT"
			    },
			    {
			      "name": "Tunisia",
			      "ISD_code": "216",
			      "code": "TN"
			    },
			    {
			      "name": "Turkey",
			      "ISD_code": "90",
			      "code": "TR"
			    },
			    {
			      "name": "Turkmenistan",
			      "ISD_code": "993",
			      "code": "TM"
			    },
			    {
			      "name": "Turks and Caicos Islands",
			      "ISD_code": "1649",
			      "code": "TC"
			    },
			    {
			      "name": "Tuvalu",
			      "ISD_code": "688",
			      "code": "TV"
			    },
			    {
			      "name": "Uganda",
			      "ISD_code": "256",
			      "code": "UG"
			    },
			    {
			      "name": "Ukraine",
			      "ISD_code": "380",
			      "code": "UA"
			    },
			    {
			      "name": "United Arab Emirates",
			      "ISD_code": "971",
			      "code": "AE"
			    },
			    {
			      "name": "United Kingdom",
			      "ISD_code": "44",
			      "code": "GB"
			    },
			    {
			      "name": "United States",
			      "ISD_code": "1",
			      "code": "US"
			    },
			    {
			      "name": "Uruguay",
			      "ISD_code": "598",
			      "code": "UY"
			    },
			    {
			      "name": "Uzbekistan",
			      "ISD_code": "998",
			      "code": "UZ"
			    },
			    {
			      "name": "Vanuatu",
			      "ISD_code": "678",
			      "code": "VU"
			    },
			    {
			      "name": "Venezuela, Bolivarian Republic of Venezuela",
			      "ISD_code": "58",
			      "code": "VE"
			    },
			    {
			      "name": "Vietnam",
			      "ISD_code": "84",
			      "code": "VN"
			    },
			    {
			      "name": "Virgin Islands, British",
			      "ISD_code": "1284",
			      "code": "VG"
			    },
			    {
			      "name": "Virgin Islands, U.S.",
			      "ISD_code": "1340",
			      "code": "VI"
			    },
			    {
			      "name": "Wallis and Futuna",
			      "ISD_code": "681",
			      "code": "WF"
			    },
			    {
			      "name": "Yemen",
			      "ISD_code": "967",
			      "code": "YE"
			    },
			    {
			      "name": "Zambia",
			      "ISD_code": "260",
			      "code": "ZM"
			    },
			    {
			      "name": "Zimbabwe",
			      "ISD_code": "263",
			      "code": "ZW"
			    }
			  ]
	    }
	  },
	  filters: {
	  },
	  mounted(){
      if (this.clickedJoin) {
        $("#signin-join").click();
        this.joinSwitch();
      }
        $('.submit-data').on('click', this.processSubmit)
        $('.skip-button').on('click', this.joinSwitch)
        $('details').on('click', this.changeFlod)
        $('details .close-accordion').on('click', this.closeAccordion)
        // styles to keep labels small if content exists
        $('input.input-style').blur(function() {
          if($(this).val()) {
            $(this).addClass('has-content')
          } else {
            $(this).removeClass('has-content')
          }
      });
	  	this.activeSection = ("guests")
	  },
	  methods: {
	  	changeFlod: function(e) {
	  		this.activeSection = $(e.currentTarget).data('section')
				// console.log(e);
				e.currentTarget.scrollIntoView({ behavior: 'smooth' });

	  	},
	    processSubmit: function(e) {

	    	// this just keeps the page from reloading by denying
	    	// the submit button submitting data and reloading page 	
	    	e.preventDefault()
	    	$('.error-text').hide()
	    	$('.sub-label').show()
	    	// use the clicked button data-form attr to pass form 'key'
	    	// basically the model we will pass on submit
	    	let formKey = $(e.target).data('form')
	    	let submitData = {}

	    	switch(formKey) {
					case 'signin': {
						// contextual and quicker form validation
						let isValid = false
						// everything checks out we move forward
						if (this.form.signin.username && this.form.signin.password && this.form.signin.terms) {
								this.registration_method = this.registration_methods.find(reg_method => reg_method.registration_method_id === 10)
								this.registration_method.langham = {
									signin: {
										username: this.form.signin.username,
			    					password: this.form.signin.password,
			    					terms: this.form.signin.terms,
			    					usernameIsMemberNumber: this.form.signin.usernameIsMemberNumber
			    				}
								}
								window.scrollTo({ top: 0, behavior: 'smooth' });
								this.emitRegistrationMethodData()
						}
						// something breaks we send it back
						// Email
						if (this.form.signin.usernameIsMemberNumber === 0) {
							isValid = false
							// field is empty
							if (!this.form.signin.username) {
								$('#username-signin ~ .error-text').show()
								$('#username-signin ~ .error-text + .error-text').hide()
							} else if (!this.validEmail(this.form.signin.username)) {
								// field exists but needs to be valid
								$('#username-signin ~ .error-text').hide()
								$('#username-signin ~ .error-text + .error-text').show()	
							} else {
								isValid = true
							}
						} else {
							isValid = false
							// Member Number
							if (!this.form.signin.username) {
								$('#membership-signin ~ .error-text').show()
							} else {
								isValid = true
							}
						}
						// Password
						if (!this.form.signin.password) {
							$('#password ~ .error-text').show()
							$('#password-signin ~ .error-text').show()
						}
						// Checkbox needs to be checked
						if (!this.form.signin.terms) {
							$('#signin-terms-accept ~ .error-text').show()
						}
						
						break;
					}
					case 'join': {
						let pwConfirm = false

						if(this.form.join.user.first_name 
							&& this.form.join.user.last_name 
							&& this.form.join.user.email 
							&& this.form.join.mobile 
							&& this.form.join.password 
							&& this.form.join.tc_internet 
							&& this.form.join.tc 
							&& this.form.join.privacy 
							&& this.form.join.info) {
							this.registration_method = this.registration_methods.find(reg_method => reg_method.registration_method_id === 10)
							this.registration_method.langham = {
								join: {
									user: {
				    				email: this.form.join.user.email,
				    				first_name: this.form.join.user.first_name,
				    				last_name: this.form.join.user.last_name
				    			},
				    			country: this.form.join.country,
                  region_id: this.form.join.region_id,
                  city_id: this.form.join.city_id,
				    			country_code: this.countries.find(c => c.code === this.form.join.country_prefix).ISD_code,
				    			mobile: this.form.join.mobile,
				    			password: this.form.join.password,
			    				tc_internet: this.form.join.tc_internet,
			    				tc: this.form.join.tc,
			    				marketing: this.form.join.marketing,
			    				privacy: this.form.join.privacy,
			    				info: this.form.join.info
				    		}
							}
							window.scrollTo({ top: 0, behavior: 'smooth' });
							this.emitRegistrationMethodData()
						}

						if(!this.form.join.user.first_name) {
							$('#first_name ~ .error-text').show()
							$('#first_name ~ .sub-label').hide()
						}

						if(!this.form.join.user.last_name) {
							$('#last_name_join ~ .error-text').show()
							$('#last_name_join ~ .sub-label').hide()
						}

						if(!this.form.join.user.email) {
							$('#join_email_address ~ .error-text').show()
							$('#join_email_address ~ .error-text + .error-text').hide()
						} else if(!this.validEmail(this.form.join.user.email)) {
							$('#join_email_address ~ .error-text').hide()
							$('#join_email_address ~ .error-text + .error-text').show()
						}

						if(!this.form.join.mobile) {
							$('#mobile_number ~ .error-text').show()
						}

						if(!this.validatePassword(this.form.join.password)) {
							$('#password-join ~ .error-text').show()
						}

						if($('#password-join').val() == $('#confirm_password').val()) {
							pwConfirm = true
						} else {
							$('#confirm_password ~ .error-text').show()
						}

						if(!this.form.join.tc_internet) {
							$('#accept-form-1 ~ .error-text').show()
						}

						if(!this.form.join.tc) {
							$('#accept-form-2 ~ .error-text').show()
						}

						if(!this.form.join.privacy) {
							$('#accept-form-3 ~ .error-text').show()
						}

						if(!this.form.join.info) {
							$('#accept-form-4 ~ .error-text').show()
						}
						break;
					}
					case 'room_guests': {
						if (this.form.room_guests.room_number && this.form.room_guests.last_name && this.form.room_guests.terms) {
							this.registration_method = this.registration_methods.find(reg_method => reg_method.registration_method_id === 2)
							window.scrollTo({ top: 0, behavior: 'smooth' });
							this.emitRegistrationMethodData()
						}

						if(!this.form.room_guests.room_number) {
							$('#room_number ~ .error-text').show()
						}

						if(!this.form.room_guests.last_name) {
							$('#last_name ~ .error-text').show()
						}

						if(!this.form.room_guests.terms) {
							$('#checkbox-guests ~ .error-text').show()
						}
						
						break;
					}
					// case 'other_guests':
					// 	this.registration_method = this.registration_methods.find(reg_method => reg_method.registration_method_id === 1)
					// 	this.emitRegistrationMethodData()
					// 	break;
					case 'access_code': {
						if(this.form.access_code.access_code && this.form.access_code.terms) {
							this.registration_method = this.registration_methods.find(reg_method => reg_method.type === "accesscode")
							window.scrollTo({ top: 0, behavior: 'smooth' });
							this.emitRegistrationMethodData()
						}

						if(!this.form.access_code.access_code) {
							$('#access_code ~ .error-text').show()
						}

						if(!this.form.access_code.terms) {
							$('#checkbox-ac ~ .error-text').show()
						}
						
						break;
					}
				 default: {break;}
				 // code to be executed if n is different from case 1 and 2
				}
	    	//console.log(formKey, submitData)
	    },
	    validEmail: function (email) {
	      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	      return re.test(email);
	    },
	    validatePassword(pw) {
		    return /[A-Z]/       .test(pw) &&
		           /[a-z]/       .test(pw) &&
		           /[0-9]/       .test(pw) &&
		           /[^A-Za-z0-9]/.test(pw) &&
		           pw.length > 8;

		},
	    emitRegistrationMethodData:function(){
	      // If no access code set, show required text
	      if(this.registration_method.type=='accesscode' && !this.form.access_code.access_code){
	        this.access_code_valid = false;
	        return;
	      }
	      if(this.clicked){
	        return;
	      }
	      this.clicked = true;


	      var emitted = {
	        registration_method_id: this.registration_method.registration_method_id,
	        rateplan_id: null,
	        email_address: null,
	        last_name: null,
	        room_number: null,
	        access_code: null,
	      };
	      if(this.registration_method.registration_method_id=='1'){
	        emitted.rateplan_id = this.registration_method.id;
	      } else if(this.registration_method.registration_method_id=='2'){
	        emitted.rateplan_id = this.registration_method.id;
	        emitted.last_name = this.form.room_guests.last_name;
	        emitted.room_number = this.form.room_guests.room_number;
	      } else if(this.registration_method.registration_method_id=='3'){
	        emitted.rateplan_id = this.registration_method.id;
	        emitted.email_address = this.form.email_address;
	      } else if(this.registration_method.registration_method_id=='4'){
	        emitted.access_code = this.form.access_code.access_code;
	      }
	      else if(this.registration_method.registration_method_id=='10'){
	        emitted.rateplan_id = this.registration_method.id;
	        emitted.langham = this.registration_method.langham
					if (this.registration_method.langham.join || this.registration_method.langham.signin) {
						// technically haven't fired off the join request (/portalregistrations), but
						// we are joining - set joined to true so we can render a different 
						// connected view if we successfully connect.
						this.joined = true;
						this.emitJoined();
					}
	      }

	      // console.log('emitted', emitted)

	      this.$emit('emitRegistrationMethodData', emitted);
	    },
	    joinSwitch: function() {
        this.fetchRegions(this.form.join.country);
        $('#signin-form, #join-form').toggle()
	    },
	    closeAccordion: function() {	    	
	    	$('details[open]').removeAttr('open')
	    },
			emitJoined: function() {
				this.$emit('emitJoined', this.joined);
			},
      fetchRegions: function (iso_code) {
        HTTP.get(`langham-location?iso_code=${iso_code}`).then(function (response) {
          this.regions = response.data;
        }.bind(this)).catch(function(error) {
          console.error(error)
        }.bind(this));
      },
      fetchCities: function (region_id) {
        HTTP.get(`langham-location?region_id=${region_id}`).then(function (response) {
          this.cities = response.data;
        }.bind(this)).catch(function(error) {
          console.error(error)
        }.bind(this));
      },
      clearCities: function () {
        this.form.city_id = '';
        this.cities = [];
      },
      clearRegions: function () {
        this.form.region_id = '';
        this.regions = [];
      },
	  }
	}
</script>

<style>
	html {font-size: 100%;}
	
	select:not([multiple],[size]) {
		padding-left: 0 !important;
	}

	ul li {
		list-style:  none !important;
	}

	input:not([type=checkbox],[type=radio]), select, textarea {
		margin-bottom: 0 !important;
	}

	.input-style {
		border: 0;
    border-radius: 0;
    outline: 0;
    background:  none;
    box-shadow: none;
    color: black;
    border-bottom: 1px solid black;
    z-index: 2;
    position: relative;
	}

	.label-style {
		font-size: 0.725rem;
    line-height: 1rem;
    text-align: left;
    position: relative;
    bottom: -40px;
	}

	.label-style:has(+ .has-content),
	.label-style:has(+ .input-style:not(select):focus) {
		font-size: .5rem;
    	bottom: -20px;
	}

	.label-style:has(+ select) {
		bottom: -12px;
		font-size: .725rem;
	}

	.make-room {
		padding: 30px 0 !important;
	}

	.top-bottom-margin {
		margin:  30px auto !important;
	}

	.error-text {
		color: red;
    font-size: .7rem;
    float: left;
    margin-bottom: -25px;
    display: none;
    margin-top: 3px;
    text-align: left;
	}

	fieldset ~ .error-text {
		margin-left: 36px;
    margin-top: -6px;
	}

	.star {
		width:  25px !important;
	}

	.welcome-head {
		margin-top: 20px;
		margin-bottom: 0;
		font-family: serif;
		font-style: normal;
    font-weight: 400;
    font-size: 1.35rem;
    line-height: 1.5rem;
    text-align: center;
    letter-spacing: 1px;
    color: #151515;
	}

	.welcome-sub {
		font-family: serif;
		font-style: normal;
    font-weight: 400;
    font-size: 1.05rem;
    line-height: 1.25rem;
    text-align: center;
    letter-spacing: 1px;
    color: #151515;
    margin-top: 5px;
	}
	
  .section-subtitle {
    display: block;
    margin-bottom: 15px;
    text-align: left;
    font-size: 12px;
  }
	.section-title {
		font-family: serif;
		font-style: normal;
		font-weight: 400;
		font-size: 0.95rem;
		line-height: 1.25rem;
		align-items: center;
    text-align: left;
		letter-spacing: 0.85px;
		color: #000000;
		margin-bottom: 15px;
		display: block;

	}

	.solid-button,
	input[type=submit] {
    width: 50% !important;
    padding: 10px 0 !important;
    font-size: 1rem !important;
    line-height: 1rem !important;
    background-color: #17dbcc;
    opacity: 0.5;
    letter-spacing: 1px !important;
    border-radius: 32px;
    color: #151515;
    font-weight: 700 !important;
    text-transform: none;
    text-decoration: none;
    cursor: pointer;
    margin-top: 10px;
    box-shadow: none;
    border: none;
    height: 37px !important;
	}

	.outline-button {
		background: #FFF;
    border-color: #151515;
    cursor: pointer;
    border-radius: 32px;
    color: #151515;
    font-weight: 700;
    text-transform: none;
    width: 100%;
    padding: 8px 0;
    font-size: 1rem;
    line-height: 1rem;
    background: #FFF;
    border: 2px solid #151515;
    cursor: pointer;
    text-decoration: none;
    margin-top: 10px;
	}

	.skip-button {
		display: block;
		color: #818181;
		font-weight: bold;
	}

	input + .skip-button {
		margin-top: 20px;
	}

	input + .skip-button.outline-button {
		margin-top: 10px;
	}

	span > .skip-button {
		display: inline-block;
		margin-left: 20px;
	}

	#langham-form {
		width: 72.5%;
    margin: 0 auto;
    max-width: 1000px;
	}

  #langham-form input {
  	font-size: 1rem;
    line-height: 1.25rem;
    letter-spacing: .6px;
    font-weight: 400;
    padding: 4px 0;
  }

  p.sub-label {
  	text-align: left;
  	font-size: .75rem;
  	margin-top: 0px;
  	color: #7f7f7f !important;
  }

	.left {
		float: left;
		clear: both;
	}

	.center {
		width:  50%;
		margin:  0 auto;
		clear: both;
		display: block;
	}

	.form-contain {
		display: block;
		width: 72.5%;
		margin: 0 auto;
		max-width: 1000px;
  }

  .form-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    padding: 0px;
    gap: 60px;
    margin-top: 10px;
  }

  .two-wrapper {
  	display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    padding: 0px;
    gap: 60px;
    margin-top: 10px;
    width: 100%;
  }

  .half {
  	width:  50%;
  }

  #signin-form {
  	display: block;
  }

  #join-form {
  	display: none;
  }

  .checkbox {
  	display: flex;
    align-items: start;
    margin: 30px 0 10px;
    text-align: left;
    font-size: .75em;
  }
  .checkbox input {
  	position: relative;
  	top: 5px;
  	width: 1rem !important;
  	height: 1rem !important;
  }

  .checkbox label {
  	width:  90%;
  	margin-left: 2%;
  }

  #langham-form p{
    color:  #151515;
  }

  #langham-form details {
    border-bottom: 1px solid #B9B9B9;
    margin-bottom: 0;
  }

  #langham-form details:last-child {
  	border:  none;
  }

  #langham-form summary {
    background: #E8F2EE;
    border:  none;
    color:  #151515;
    border-radius: 0;
   padding: 0;
  }

  #langham-form details summary::after {
    display: none;
  }

  summary .flod {
  	position: absolute;
    width: 25px;
    height: 25px;
    margin-left: 70px;
    margin-top: 21px;
  }

  summary p {
  	text-align: left;
    font-size: 1.35rem;
    line-height: 1.5rem;
    margin: 0;
    font-family: "Baskerville";
    margin-left: 120px;
    padding: 20px 0;
  }


  @media (max-width: 768px) {
  	 #langham-form {
		width: 100%;
	    margin: 0 auto;
	    max-width: 1000px;
	}

	.welcome-head {
		font-size: 1rem;
	}

	.welcome-sub {
		font-size: .9rem;
	}

  	.logo {
  		margin: 50px auto 25px auto !important;
  	}
  	.two-wrapper {
  		flex-direction: column;
  		gap:  5px;
  	}
  	.half {
  		width: 100%;
  	}
  	.solid-button, input[type=submit] {
  		width: 100% !important;
  	}
  	p.subtitle {
  		padding: 0 175px;
  		font-size: .9rem !important;
  	}
  	summary .flod {
  		margin-left: 20px;
  	}
  	summary p {
  		font-size: 1rem;
  		margin-left:60px;
  	}
  }
</style>